
import { getUserData, googleLogin } from '../../api/user'
import { loginInfoState, userInfoState } from '../states/user'
// import { signOutGoogle } from '../../utils/googleAuth'
import { setToken } from '../../utils/auth'
import {
  SET_TOKEN,
  SET_USERINFO,
  LOGOUT,
} from '../mutation-types'

const user = {
  namespaced: true,
  state: {
    loginInfo: loginInfoState(),
    userInfo: userInfoState(),
  },
  getters: {
    id: state => state.userInfo.id,
    name: state => state.userInfo.name,
    token: state => state.loginInfo.token,
    accessibleRoutes: (state) => {
      const { accessibleRoutes } = state.userInfo
      if (Array.isArray(accessibleRoutes) && accessibleRoutes.length > 0) {
        return accessibleRoutes
      }
      return []
    },
    isLoggedIn: state => !!state.loginInfo.token,
    loadedUserInfoOnce: state => state.loginInfo.loadedUserInfoOnce,
  },
  actions: {
    async loginWithGoogle({ commit }, googleAccessToken) {
      const response = await googleLogin(googleAccessToken)
      const {
        admin: userInfo,
        access_token: token,
      } = response.data

      commit(SET_USERINFO, userInfo)
      commit(SET_TOKEN, token)

      return response
    },
    async getUserInfo({ commit }) {
      const response = await getUserData()
      const userInfo = response.data
      commit(SET_USERINFO, userInfo)
      return response
    },
    async logout({ commit }) {
      commit(LOGOUT)
      // return signOutGoogle().then(() => {
      //   commit(LOGOUT)
      // }).catch((error) => {
      //   commit(LOGOUT)
      //   return error
      // })
    },
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token)
      state.loginInfo.token = token
    },
    SET_USERINFO: (state, {
      id,
      type,
      email,
      name,
      enabled,
      permissions
    }) => {
      state.userInfo.id = id
      state.userInfo.type = type
      state.userInfo.email = email
      state.userInfo.name = name
      state.userInfo.enabled = enabled
      state.userInfo.accessibleRoutes = permissions
      state.loginInfo.loadedUserInfoOnce = true

      localStorage.setItem('user_id', id)
      localStorage.setItem('user_type', type)
      localStorage.setItem('user_email', email)
      localStorage.setItem('user_name', name)
      localStorage.setItem('user_enabled', enabled)
    },
    LOGOUT: (state) => {
      localStorage.clear()
      state.loginInfo = loginInfoState()
      state.userInfo = userInfoState()
    },
  },
}

export default user
